<div class="mt-4">
  <div class="alert alert-info" role="alert" *ngIf="showNewPatientMessage">
    Please complete the PMH, Family History and Social History for this patient.
  </div>
  <div *ngFor="let section of sections" id="{{ 'section_' + section.alias }}">
    <noteSection-item [config]="section" [topOffset]="topOffset"></noteSection-item>
  </div>
</div>